import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { DataService } from 'src/app/dashboards/services/data.service';
import { AuthenticationResult } from 'src/app/shared/models/authentication-result';
import { UserNotificationResponseDto } from 'src/app/shared/models/responses/user-notification.response';
import { UiStateStore } from 'src/app/shared/store/ui-state-store.service';
import { Navigation } from '../../../../shared/models/navigation';

@Component({
  selector: 'app-dashboard-employer-menu',
  templateUrl: './dashboard-menu.component.html',
  styleUrls: ['./dashboard-menu.component.scss']
})
export class DashboardEmployerMenuComponent implements OnInit, OnDestroy {

  navigations: Navigation[] = Navigation.getEmployerNavigations().filter(n => n.title != "Search Candidates");
  stylesArray: string[] = [];
  subscriptions: Subscription[] = [];
  userNotifications: UserNotificationResponseDto[] = [];
  unreadCount: number;
  user: AuthenticationResult = null;
  constructor(private authenticationService: AuthenticationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private uiState: UiStateStore,
    private dataService: DataService) {
    this.resetStyles();
    this.stylesArray[0] = "active";

    this.subscriptions.push(
    this.router.events.subscribe(val => {
      if (!this.activatedRoute.snapshot.firstChild) {
        return;
      }

      let childRoute = this.activatedRoute.firstChild.snapshot.url[0].path;
      let navigationIndex = this.navigations.findIndex(n => n.route.indexOf(childRoute) > -1);
      this.onMenuClicked(navigationIndex);
    }));

    this.uiState.authenticatedUser.subscribe((user) => {
      if (!user) {
        return;
      }

      this.user = user;
      this.getUserNotifications();
    });

    this.uiState.currentNotification$.subscribe(resp => {
      if(resp && resp.notificationId){
        const existingNotification = this.userNotifications.find(x => x.notificationId == resp.notificationId);
        if(existingNotification) {
          this.userNotifications.forEach((x) => {
            if (x.notificationId == resp.notificationId) {
              x.isRead = true;
            }
          });
        } else {
          this.userNotifications.unshift(resp);
        }
        this.unreadCount = this.userNotifications.filter((x) => !x.isRead).length;
      }
    });
  }

  getUserNotifications = () => {
    this.dataService
      .getUserNotifications(this.user.accountId)
      .subscribe((resp) => {
        this.userNotifications = resp;
        this.unreadCount = this.userNotifications.filter((x) => !x.isRead).length;
      });
  };

  isMessagesTab = (navigation: Navigation) => {
    return navigation.title === "Messages";
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public onMenuClicked(itemIndex): void {
    this.resetStyles();
    this.stylesArray[itemIndex] = "active";
  }

  resetStyles(): void {
    for (let i = 0; i < 6; i++) {
      this.stylesArray[i] = "";
    }
  }
}
